<!-- EntityPhone.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { PhoneType } from '../../Enums/ChoiceEnums';
    import { IEntityInfoById } from '../../lib/Models/EntityModel';
    import Phone from "./Phone.vue"
    import { phoneInfo, IPhoneInfo } from '../../lib/Formatting/Entity';

    const props = defineProps<{
        entityInfo?: IEntityInfoById
    }>();

    const phoneTitleInfo: Record<PhoneType, string> = 
    {
        [PhoneType.Home]: "Home",
        [PhoneType.Work]: "Work",
        [PhoneType.Other]: "Other",
        [PhoneType.Fax]: "Fax",
    }

    const phoneTitle = computed<string|undefined>(() => {
        if (undefined === props.phoneType)
            return;
         return phoneTitleInfo[props.phoneType];
    });

 
    const entityPhoneInfo = computed<IPhoneInfo|undefined>(() => phoneInfo(props.entityInfo, props.phoneType));

    const showNumber = computed(() => {
        return props.entityInfo && entityPhoneInfo.value && entityPhoneInfo.value.phone?.length
    });

    const homePhone = computed(() => phoneInfo(props.entityInfo, PhoneType.Home));
    const workPhone = computed(() => phoneInfo(props.entityInfo, PhoneType.Work));    
    const otherPhone = computed(() => phoneInfo(props.entityInfo, PhoneType.Other));    
    const faxPhone = computed(() => phoneInfo(props.entityInfo, PhoneType.Fax));    

    function showPhone(info: IPhoneInfo): boolean
    {
        return (info.phone?.trim()?.length ?? 0) > 0;
    }

    const phoneNumberItems = computed<(IPhoneInfo|undefined)[]>(() => [homePhone.value, workPhone.value, otherPhone.value, faxPhone.value]);
</script>

<template>
    <template v-for="phoneItem in phoneNumberItems">
        <template v-if="phoneItem && showPhone(phoneItem)">
            <slot name="phone" :phone="phoneItem">
                <div>            
                    {{ phoneTitleInfo[phoneItem?.phoneType] }}:
                    <Phone :phone="phoneItem.phone" :ext="phoneItem.ext" />
                </div>
            </slot>
        </template>
    </template>
</template>